import { z } from 'zod';

export const searchSchema = z.object({
  ngay_ct1: z.string().optional().nullable(),
  ngay_ct2: z.string().optional().nullable(),
  so_ct1: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  ma_gd: z.string().optional().nullable(),
  dien_giai: z.string().optional().nullable(),
  ma_kh: z.string().optional().nullable(),
  tk: z.string().optional().nullable(),
  tk_no: z.string().optional().nullable(),
  ma_unit: z.string().optional().nullable(),
  status: z.string().optional().nullable(),
  user_id0: z.string().optional().nullable()
});

export type SearchFormValues = z.infer<typeof searchSchema>;

export const initialSearchValues: SearchFormValues = {
  ngay_ct1: '',
  ngay_ct2: '',
  so_ct1: '',
  so_ct2: '',
  ma_gd: '',
  dien_giai: '',
  ma_kh: '',
  tk: '',
  tk_no: '',
  ma_unit: '',
  status: '',
  user_id0: ''
};

export const formSchema = z.object({
  // BasicInfoTab fields
  ma_so_thue: z.string().optional().nullable(),
  ten_kh_thue: z.string().optional().nullable(),
  dia_chi: z.string().optional().nullable(),
  ong_ba: z.string().optional().nullable(),
  e_mail: z.string().optional().nullable(),
  dien_giai: z.string().nonempty('Diễn giải không được để trống'),
  ngay_ct: z.string().optional().nullable(),
  so_ct0: z.string().optional().nullable(),
  so_ct2: z.string().optional().nullable(),
  ngay_ct0: z.string().optional().nullable(),
  ty_gia: z.coerce.number().optional().nullable(),
  status: z.string().optional().nullable(),
  ma_nt: z.string().optional().nullable(),
  transfer_yn: z.boolean().optional().nullable(),

  // EInvoiceTab fields
  ma_tthddt: z.string().optional().nullable(),
  ma_pttt: z.string().optional().nullable(),
  so_ct_hddt: z.string().optional().nullable(),
  ngay_ct_hddt: z.string().optional().nullable(),
  so_ct2_hddt: z.string().optional().nullable(),
  ma_mau_ct_hddt: z.string().optional().nullable(),

  // OtherTab fields
  invat_yn: z.boolean().optional().nullable(),
  ma_mau_bc: z.string().optional().nullable(),
  ma_tc_thue: z.string().optional().nullable(),
  ma_gd: z.string().optional().nullable(),
  ghi_chu: z.string().optional().nullable(),
  ly_do: z.string().optional().nullable(),

  // SummaryTab fields
  t_tien_nt: z.coerce.number().optional().nullable(),
  t_tien: z.coerce.number().optional().nullable(),
  t_ck_nt: z.coerce.number().optional().nullable(),
  t_ck: z.coerce.number().optional().nullable(),
  t_tc_tien_nt2: z.coerce.number().optional().nullable(),
  t_tc_tien: z.coerce.number().optional().nullable(),
  t_km_nt: z.coerce.number().optional().nullable(),
  t_km: z.coerce.number().optional().nullable(),

  // BottomActionBarV2 fields
  t_so_luong: z.coerce.number().optional().nullable(),
  t_thue_nt: z.coerce.number().optional().nullable(),
  t_thue: z.coerce.number().optional().nullable(),
  t_tt_nt: z.coerce.number().optional().nullable(),
  t_tt: z.coerce.number().optional().nullable()
});

export type FormSchema = z.infer<typeof formSchema>;

export const initialFormValues: FormSchema = {
  // BasicInfoTab fields
  ma_so_thue: '',
  ten_kh_thue: '',
  dia_chi: '',
  ong_ba: '',
  e_mail: '',
  dien_giai: '',
  ngay_ct: new Date().toISOString().split('T')[0],
  so_ct0: '',
  so_ct2: '',
  ngay_ct0: null,
  ma_nt: '',
  ty_gia: 1,
  status: '5',
  transfer_yn: false,

  // EInvoiceTab fields
  ma_tthddt: '0',
  so_ct_hddt: '',
  ngay_ct_hddt: '',
  so_ct2_hddt: '',
  ma_mau_ct_hddt: '',

  // OtherTab fields
  invat_yn: false,
  ma_mau_bc: '3',
  ma_tc_thue: null,
  ma_gd: '',
  ghi_chu: '',
  ly_do: '',

  // SummaryTab fields
  t_tien_nt: 0,
  t_tien: 0,
  t_ck_nt: 0,
  t_ck: 0,
  t_tc_tien_nt2: 0,
  t_tc_tien: 0,
  t_km_nt: 0,
  t_km: 0,

  // BottomActionBarV2 fields
  t_so_luong: 0,
  t_thue_nt: 0,
  t_thue: 0,
  t_tt_nt: 0,
  t_tt: 0
};
